export default "__VITE_ASSET__BVZ6DOmI__"